import { render } from "./FooterComp.vue?vue&type=template&id=690ee3fc"
import script from "./FooterComp.vue?vue&type=script&lang=js"
export * from "./FooterComp.vue?vue&type=script&lang=js"

import "./FooterComp.vue?vue&type=style&index=0&id=690ee3fc&lang=css"

import exportComponent from "D:\\Github\\cj-assets\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__